import { useEffect, useRef, useState } from 'react'
import { useStore } from '../../../module/rootStore'

const GAP = '16px'
const MOBILE_WIDTH = 790

const useStep = () => {
  const { stepsInputs, currentStep, inputLayout } = useStore().StepsStore
  const [clientWidth, setClientWidth] = useState<number>(
    //window.innerWidth ||
    document.documentElement.clientWidth || document.body.clientWidth
  )
  const wrapperRef = useRef<HTMLDivElement>(null)
  const inputsRefs = useRef<HTMLElement[]>(
    stepsInputs && currentStep && Array.isArray(stepsInputs[currentStep])
      ? new Array(stepsInputs[currentStep].length)
      : []
  )
  const handleWindowResize = () => {
    setClientWidth(
      document.documentElement.clientWidth || document.body.clientWidth
    )
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  useEffect(() => {
    if (
      stepsInputs &&
      Array.isArray(stepsInputs[currentStep]) &&
      inputLayout[currentStep] &&
      clientWidth &&
      clientWidth >= MOBILE_WIDTH
    ) {
      const inputsPerRow = inputLayout[currentStep].split(' ').map(Number)
      stepsInputs[currentStep].forEach((_, index) => {
        let rowNumber = 0
        for (
          let i = 0, inputsCount = 0;
          i < inputsPerRow.length;
          i++, rowNumber++
        ) {
          inputsCount += inputsPerRow[i]
          if (inputsCount > index) {
            //rowNumber = i
            break
          }
        }

        const inputsCount = inputsPerRow[rowNumber]
        const widthStr =
          inputsCount === 1
            ? `100%`
            : `calc((100% - ${GAP} * (${inputsCount} - 1)) / ${inputsCount})`

        inputsRefs?.current[index]?.style && (inputsRefs.current[index].style.flexBasis = widthStr)
        inputsRefs?.current[index]?.style && (inputsRefs.current[index].style.width = widthStr)
        inputsRefs?.current[index]?.style && (inputsRefs.current[index].style.marginBottom = '0px')
        // element?.style && (element.style.marginBottom = '0px')
      })

    } else if (clientWidth && clientWidth < MOBILE_WIDTH) {
      inputsRefs?.current?.forEach((element) => {
        if (element) {
          element?.style && (element.style.flexBasis = '100%')
          element?.style && (element.style.width = 'unset')
          
        }
      })
    }
  }, [currentStep, clientWidth])

  return {
    wrapperRef,
    inputsRefs,
  }
}

export default useStep
